"use client";

import { motion, Variants } from "framer-motion";

export default function WebusAfterSection() {
  const fadeUp: Variants = {
    hidden: { opacity: 0, y: 40 },
    visible: (delay = 0) => ({
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        delay,
        ease: "easeOut",
      },
    }),
  };

  return (
    <section
      className="w-full relative bg-center text-white overflow-hidden mt-20 md:mt-40"
      style={{
        backgroundImage:
          "url('/assets/images/page/service/webus/afterBackground.jpeg')",
        backgroundRepeat: "no-repeat",
      }}
    >
      <style jsx>{`
        section {
          background-size: cover;
        }
        @media (min-width: 991px) {
          section {
            background-size: 115%;
          }
        }
      `}</style>
      {/* 반투명 오버레이 */}
      <div className="absolute inset-0 bg-[#444]/30" />

      {/* 컨텐츠 */}
      <div className="relative flex flex-col items-center justify-center w-full xl:max-w-[1280px] mx-auto px-5 xl:px-2 py-24 md:py-40 text-center z-10">
        {/* 타이틀 섹션 */}
        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.5 }}
          className="text-center"
        >
          <p
            className="text-light-10 sm:text-xl text-sm"
            style={{ fontFamily: '"pre-Medium", sans-serif' }}
          >
            After
          </p>

          <motion.p
            variants={fadeUp}
            custom={0.2}
            className="text-[26px] sm:text-3xl md:text-5xl text-white md:mt-14 md:mb-10 sm:mt-10 sm:mb-5 mt-8 mb-5 leading-9 sm:leading-10 md:leading-16"
            style={{ fontFamily: '"pre-Bold", sans-serif' }}
          >
            서비스 도입 이후, <br />
            저상버스 이용률 70배 증가!
          </motion.p>

          <motion.p
            variants={fadeUp}
            custom={0.4}
            className="text-base md:text-2xl text-light-10 tracking-tight md:leading-10 sm:leading-7 leading-[26px]"
            style={{ fontFamily: "pre-Medium, sans-serif" }}
          >
            이제 저상버스 이동이 불가능이 아닌 &lsquo;일상&rsquo;이 됩니다.
          </motion.p>
        </motion.div>

        {/* 도표 섹션 */}
        <motion.div
          variants={fadeUp}
          custom={0.6}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.4 }}
          className="py-10 xl:py-30 flex flex-row space-y-10 sm:space-y-0 space-x-8 sm:space-x-20 items-end mt-4 md:mt-10 w-full justify-center"
        >
          {/* 도입 전 */}
          <div className="flex flex-col items-center">
            <div className="bg-[#E4E8EB] h-24 lg:h-40 lg:px-16 px-7 md:px-10 py-5 rounded-2xl flex items-center justify-center">
              <span
                className="text-[#9C9C9C] text-lg md:text-3xl"
                style={{ fontFamily: '"pre-SemiBold", sans-serif' }}
              >
                13회
              </span>
            </div>
            <p
              className="mt-8  text-sm md:text-lg  tracking-tight text-[#E7E7E7]"
              style={{ fontFamily: '"pre-Regular", sans-serif' }}
            >
              도입 전 연간 이용률
            </p>
          </div>

          {/* 도입 후 */}
          <div className="flex flex-col items-center relative">
            <div className="bg-[#4880ED] h-64 lg:h-80 lg:px-16  px-7 md:px-10 py-5 rounded-2xl flex items-center justify-center relative">
              <span
                className="text-white text-lg md:text-3xl"
                style={{ fontFamily: '"pre-SemiBold", sans-serif' }}
              >
                912회
              </span>

              {/* 강조 라벨 */}
              <motion.div
                variants={fadeUp}
                custom={0.8}
                className="md:w-24 md:h-24 w-20 h-20 lg:w-30 lg:h-30 bg-[#C3FF7E] absolute bottom-[-30px] right-[-50px] rounded-full flex flex-col justify-center items-center text-black-almostBlack text-sm md:text-base lg:text-xl tracking-tight leading-5 md:leading-6 text-center"
                style={{
                  fontFamily: '"paperlogy-Medium", sans-serif',
                  boxShadow: "14px 9px 12.3px rgba(90, 90, 90, 0.24)",
                }}
              >
                이용횟수
                <br />
                70배 증가
              </motion.div>
            </div>
            <p
              className="mt-8 text-sm md:text-lg tracking-tight text-[#E7E7E7]"
              style={{ fontFamily: '"pre-Regular", sans-serif' }}
            >
              도입 후 연간 이용률
            </p>
          </div>
        </motion.div>

        {/* 설명 문단 */}
        <motion.p
          variants={fadeUp}
          custom={1.0}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
          className="text-sm md:text-xl lg:text-2xl tracking-tight text-light-40 leading-6 md:leading-8 lg:leading-10 mt-4 md:mt-10"
          style={{ fontFamily: '"pre-Regular", sans-serif' }}
        >
          평균 한 달에 한 번도 이용하기 어려웠던 저상버스
          <br />
          이제는 매일같이 저상버스를 쉽게 이용할 수 있게 되었습니다.
        </motion.p>
      </div>
    </section>
  );
}
